import { DeepPartial } from "@reduxjs/toolkit";
import { httpClient } from "@/http";
import {
  UserCreate,
  UserQueryParams,
  UserRead,
  MyNotification,
  MyRates,
  MyRounds,
} from "./types";

export const UserService = {
  /** 列出使用者清單 */
  list(params: UserQueryParams = {}) {
    return httpClient<HttpResponse<{ users: UserRead[] }>>().get(
      "/api/v1/users",
      params
    );
  },
  create(data: { user: UserCreate }) {
    return httpClient<HttpResponse<{ user: UserRead }>>().post(
      "/api/v1/users",
      data
    );
  },
  update(userId: string, data: { user: DeepPartial<UserCreate> }) {
    return httpClient<HttpResponse<{ user: UserRead }>>().patch(
      `/api/v1/user/${userId}`,
      data
    );
  },
  getMyNotify() {
    return httpClient<HttpResponse<MyNotification>>().get(
      "/api/v1/user/me/notify"
    );
  },
  getMyRates() {
    return httpClient<HttpResponse<MyRates>>().get("/api/v1/user/me/rates");
  },
  getMyRounds() {
    return httpClient<HttpResponse<MyRounds>>().get("/api/v1/user/me/rounds");
  },
};
